var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","flat":""}},[_c('b',[_vm._v("Comment Mode")])]),_c('v-card-media',{staticClass:"absolute pa-5",attrs:{"src":_vm.src,"width":"800"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }